import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetClientAdminUser } from '~/hooks';

type Args = {
  clientAdminUserId: number;
};

export const useEditClientAdminUserFormHeader = ({ clientAdminUserId }: Args) => {
  const { data } = useGetClientAdminUser({
    threeLetterCode: getThreeLetterCode() || '',
    id: clientAdminUserId,
  });
  return { fullName: data.client_admin_user.full_name };
};
